module.exports = __webpack_public_path__ + "static/media/AC.9ee19a01.svg";